import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

interface Script {
  image?: string;
  title: string;
  gameLink: string;
  discordInvite?: string;
  description: string;
  content: string;
  tags?: string[];
  isMobile: boolean;
  hasKeySystem: boolean;
  isPaid: boolean;
}

interface ScriptStore {
  script: Script;
  updateScript: (updates: Partial<Script>) => void;
  clearScript: () => void;
}

const initialScript: Script = {
  title: "",
  gameLink: "",
  discordInvite: "",
  description: "",
  content: "",
  tags: [],
  isMobile: false,
  hasKeySystem: false,
  isPaid: false,
};

export const useScriptStore = create<ScriptStore>()(
  persist(
    (set) => ({
      script: initialScript,
      updateScript: (updates) =>
        set((state) => ({
          script: { ...state.script, ...updates },
        })),
      clearScript: () => set({ script: initialScript }),
    }),
    {
      name: "script-storage",
    },
  ),
);
